import { sortBy } from 'lodash';
import { createSelector } from 'reselect';
import { mapAssetGroups } from './helpers';
import { mapUnknownCountry } from 'helpers/filterHelper';
import { getOrganizations } from 'helpers/selectors';


const getRawSites = ({ generalFilter }) => {
    return generalFilter.sites.data;
};

const getAssetGroups = createSelector([
    ({ generalFilter }) => generalFilter.assetGroups.data,
], (
    rawAssetGroups,
) => {
    const mappedGroups = mapAssetGroups(rawAssetGroups);
    return mappedGroups;
});

const getSelectedFilterCountries = createSelector([
    ({ generalFilter }) => generalFilter.selectedFilters.countries,
], (
    countries,
) => {
    return mapUnknownCountry(countries);
});

const getSelectedFilterSites = createSelector([
    ({ generalFilter }) => generalFilter.selectedFilters.sites,
], (
    sites,
) => {
    return sortBy(sites, (o) => (o.siteName || '').toLowerCase());
});

const getSelectedFilterOrganizations = createSelector([
    ({ generalFilter }) => generalFilter.selectedFilters.organizations,
], (
    organizations,
) => {
    return sortBy(organizations, (o) => (o.organizationName || '').toLowerCase());
});

const getSelectedFilters = createSelector([
    ({ generalFilter }) => generalFilter.selectedFilters,
    getSelectedFilterOrganizations,
    getSelectedFilterCountries,
    getSelectedFilterSites
], (
    selectedFilters,
    organizations,
    countries,
    sites
) => {
    return {
        ...selectedFilters,
        organizations,
        countries,
        sites
    };
});

const getLoadingStatuses = ({ generalFilter }) => {
    return {
        organizationsLoadingStatus: generalFilter.organizations.loadingStatus,
        sitesLoadingStatus: generalFilter.sites.loadingStatus,
        assetGroupsLoadingStatus: generalFilter.assetGroups.loadingStatus,
        contextLoadingStatus: generalFilter.contextLoadingStatus
    };
};

const getEnvironment = ({ portal }) =>
    portal.environmentProperties.data && portal.environmentProperties.data.environment;

export const getAssets = ({ overview }) => {
    return overview?.assets?.data;
};

export const isAdmin = ({ overview }) => {
    return overview?.user?.data?.isAdminFromCIAM;
};

export const isCIAMSyncFlag = ({ generalFilter }) => {
    return generalFilter?.refeshCIAMSync;
};

export const isRefreshPowertrains = ({ generalFilter }) => {
    return generalFilter?.refreshPowertrains;
};

export const isRefreshAssetGroups = ({ generalFilter }) => {
    return generalFilter?.refreshAssetGroups;
};

export const isRefreshAssets = ({ generalFilter }) => {
    return generalFilter?.refreshAssets;
};

const getUserCapabilities = ({ overview }) => {
    return overview?.userCapabilities;
};


const getLastSelectedOrganization = ({ generalFilter }) => {
    return generalFilter?.lastSelectedOrganization;
};

const getFleetUserType = ({ fleetOverview }) => {
    return { isREC: fleetOverview?.isREC, isLSU: fleetOverview?.isLSU };
};


export const getModel = createSelector([
    getOrganizations,
    getRawSites,
    getAssetGroups,
    getSelectedFilters,
    getEnvironment,
    getLoadingStatuses,
    getAssets,
    isAdmin,
    isCIAMSyncFlag,
    isRefreshPowertrains,
    isRefreshAssetGroups,
    isRefreshAssets,
    getUserCapabilities,
    getLastSelectedOrganization,
    getFleetUserType
], (
    organizations,
    rawSites,
    assetGroups,
    selectedFilters,
    environment,
    loadingData,
    assets,
    isAdmin,
    isCIAMSyncFlag,
    isRefreshPowertrains,
    isRefreshAssetGroups,
    isRefreshAssets,
    userCapabilities,
    lastSelectedOrganization,
    fleetUserType
) => {
    return {
        organizations,
        rawSites,
        assetGroups,
        selectedFilters,
        environment,
        loadingData,
        assets,
        isAdmin,
        isCIAMSyncFlag,
        isRefreshPowertrains,
        isRefreshAssetGroups,
        isRefreshAssets,
        userCapabilities,
        lastSelectedOrganization,
        fleetUserType
    };
});
